/**
 * Created by JianJia.Zhou<jianjia.zhou> on 2023/12/07.
 */
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function login(data) {
  return request({
    url: `/passport/pc/login`,
    method: 'post',
    data
  })
}

export function isLogin() {
  return !!getToken()
}

export default {
  login,
  isLogin
}
